import React from 'react';
import { ActivityIndicator } from 'antd-mobile';

import styles from './pageLoading.less';

export default function PageLoading() {
  return (
    <div className={styles.loadingBox}>
      <ActivityIndicator size="large" />
    </div>
  );
}
